import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import styles from './Nav.module.scss';
import Image from '../../Image';
import menu from '../../../assets/nav/menu.png';
import useBreakpoints from '../../../hooks/use-breakpoints';
import RailsMobileNav from "./RailsMobileNav";
import {routes} from "../../../routes";
import logo from "../../../assets/logo.jpg";

const EmployeeNav = ({ currentUser }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [unreadSmsCount, setUnreadSmsCount] = useState(0);
  const breakpoint = useBreakpoints();
  const isSignedIn = true;

  const getCurrentDomain = () => {
    const hostname = window.location.hostname;
    if (hostname.includes('shoob.cloud')) {
      return 'https://www.shoob.cloud';
    } else {
      return 'https://www.shoobphoto.com';
    }
  }

  useEffect(() => {
    if (!isOpen) return;

    setIsLoginOpen(false);
  }, [isOpen]);

  useEffect(() => {
    if (!isLoginOpen) return;

    setIsOpen(false);
  }, [isLoginOpen]);

  const [isOpenYB, setIsOpenYB] = useState(false);
  const [isLoginOpenYB, setIsLoginOpenYB] = useState(false);
  const [isYBGradePagesOpen, setIsYBGradePagesOpen] = useState(false);

  useEffect(() => {
    if (!isOpenYB) return;

    setIsLoginOpenYB(false);
  }, [isOpenYB]);

  useEffect(() => {
    if (!isLoginOpenYB) return;

    setIsOpenYB(false);
  }, [isLoginOpenYB]);

  // Fetch unread SMS count on mount and poll every 30 seconds
  useEffect(() => {
    const fetchUnreadCount = async () => {
      try {
        const response = await fetch('/admin/sms_conversations/unread_count');
        if (response.ok) {
          const data = await response.json();
          setUnreadSmsCount(data.count);
        }
      } catch (error) {
        console.error('Failed to fetch unread SMS count:', error);
      }
    };

    fetchUnreadCount();
    const interval = setInterval(fetchUnreadCount, 30000);
    return () => clearInterval(interval);
  }, []);

  // Employee mobile navigation
  console.log(breakpoint)
  if (['lg', 'md', 'sm'].includes(breakpoint)) return (
    <nav
      className={cn({
        [styles.navContainer]: true,
        noPrint: true,
        'rails-nav': true,
      })}
      style={{ display: 'flex', justifyContent: 'space-between' }}
    >
      <div className={cn(styles.cartLink, styles.dropdown)} style={{ marginLeft: '1em' }}>
        <button
          className={styles.button}
          style={{ padding: '.5em' }}
          onClick={() => setIsLoginOpen(!isLoginOpen)}
          type="button"
        >
          <Image alt="Menu" src={menu} />
        </button>
        <ul
          className={cn({
            [styles.dropdownMenu]: true,
            [styles.hidden]: !isLoginOpen,
          })}
        >
          <li>
            <a href="/pages/home">
              Home Page
            </a>
          </li>
          <li>
            <a href="/">
              Customer Home Page
            </a>
          </li>
          <li>
            <a href="/admin/school_overview">
              Schools
            </a>
          </li>
          <li>
            <a href="/djobs?type=confirms">
              Jobs
            </a>
          </li>
          <li>
            <a href="/dprojects">
              Projects
            </a>
          </li>
          <li>
            <a href="/yearbook_requests/new">
              Yearbook Sign Up
            </a>
          </li>
          <li>
            <a href="/order_packages">
              Yearbook Sales
            </a>
          </li>
          <li>
            <a href="/order_packages/choose_yearbook_sales_or_submit">
              Class Pages by Teacher
            </a>
          </li>
          <li>
            <a href={`/schools/${currentUser.school_id}/download_all_grade_yb_pages?photos_per_row=7`}>
              Class Pages by Grade
            </a>
          </li>
          <li>
            <a href="/yearbooks/templates">
              Canva Cover Templates
            </a>
          </li>
          <li>
            <a href="/yearbook_submissions/new?cover_only=yes">
              Submit Cover
            </a>
          </li>
          <li>
            <a href="/yearbook_submissions/new?cover_only=no">
              Submit Yearbook
            </a>
          </li>
          <li>
            <a href="/yearbook_submissions">
              Yearbook Submissions
            </a>
          </li>
          <li>
            <a href="/yearbook_admin_jobs">
              Yearbook Jobs
            </a>
          </li>
          <li>
            <a href="/export/students">
              Students
            </a>
          </li>
          <li>
            <a href="/orders">
              Orders
            </a>
          </li>
          <li>
            <a href="/admin/dashboards">
              Dashboard
            </a>
          </li>
          <li>
            <a href="/admin/sms_conversations" style={{ display: 'flex', alignItems: 'center', gap: '0.5em' }}>
              Messages
              {unreadSmsCount > 0 && (
                <span style={{
                  backgroundColor: '#dc3545',
                  color: 'white',
                  borderRadius: '10px',
                  padding: '2px 8px',
                  fontSize: '12px',
                  fontWeight: 'bold'
                }}>
                  {unreadSmsCount}
                </span>
              )}
            </a>
          </li>
          <li>
            <a rel="nofollow" data-method="delete" href="/users/sign_out">
              Logout
            </a>
          </li>
        </ul>
      </div>
      <a href="/" style={{ paddingRight: '1em' }}>
        <Image src={logo} classes={styles.logo} />
      </a>
    </nav>
  );

  // Employee desktop navigation
  return (
    <nav
      className={cn({
        [styles.navContainer]: true,
        noPrint: true,
        'rails-nav': true,
      })}
    >
      <div className={cn(styles.cartLink, styles.dropdown)} style={{ marginLeft: '1em' }}>
        <button
          className={styles.button}
          style={{ padding: '.5em' }}
          onClick={() => setIsLoginOpen(!isLoginOpen)}
          type="button"
        >
          <Image alt="Menu" src={menu} />
        </button>
        <ul
          className={cn({
            [styles.dropdownMenu]: true,
            [styles.hidden]: !isLoginOpen,
          })}
        >
          <li>
            <a href="/pages/home">
              Home Page
            </a>
          </li>
          <li>
            <a href="/">
              Customer Home Page
            </a>
          </li>
        </ul>
      </div>
      <ul className={styles.nav}>
        <li>
          <a href="/admin/school_overview">
            Schools
          </a>
        </li>
        <li>
          <a href="/djobs?type=confirms">
            Jobs
          </a>
        </li>
        <li>
          <a href="/dprojects">
            Projects
          </a>
        </li>
        <li>
          <a href="/admin/shop/products">
            Shop Catalog
          </a>
        </li>


        <li className={styles.dropdown}>
          <button
            className={styles.button}
            onClick={() => setIsOpenYB(!isOpenYB)}
            type="button"
          >
            Yearbooks
          </button>
          <ul
            className={cn({
              [styles.dropdownMenu]: true,
              [styles.hidden]: !isOpenYB,
            })}
          >
            <li>
              <a href={`/yearbook_requests/new`}>Sign Up</a>
            </li>
            <li>
              <a href={`/order_packages`}>Sales</a>
            </li>
            <li>
              <a href="/order_packages/choose_yearbook_sales_or_submit">
                Class Pages by Teacher
              </a>
            </li>
            <li className={styles.dropdown}>
              <button
                className={styles.buttonleft}
                onClick={(e) => {
                  e.stopPropagation();
                  setIsYBGradePagesOpen(!isYBGradePagesOpen);
                }}
                type="button"
              >
                Class Pages by Grade
              </button>
              <ul
                className={cn({
                  [styles.dropdownMenu]: true,
                  [styles.submenu]: true,
                  [styles.hidden]: !isYBGradePagesOpen,
                })}
                  ><li><a href={`/schools/${currentUser.school_id}/download_all_grade_yb_pages?photos_per_row=7`}>Default</a></li>
                  <li><a href={`/schools/${currentUser.school_id}/download_all_grade_yb_pages?photos_per_row=5`}>5 photos per row</a></li>
                  <li><a href={`/schools/${currentUser.school_id}/download_all_grade_yb_pages?photos_per_row=6`}>6 photos per row</a></li>
                  <li><a href={`/schools/${currentUser.school_id}/download_all_grade_yb_pages?photos_per_row=7`}>7 photos per row</a></li>
                </ul>
            </li>
            <li>
              <a href={`/yearbooks/templates`}>Canva Cover Templates</a>
            </li>
            <li>
              <a href={`/yearbook_submissions/new?cover_only=yes`}>Submit Cover</a>
            </li>
            <li>
              <a href={`/yearbook_submissions/new?cover_only=no`}>Submit Yearbook</a>
            </li>
            <li>
              <a href={`/yearbook_submissions`}>Yearbook Submissions</a>
            </li>
            <li>
              <a href="/yearbook_admin_jobs">Yearbook Jobs</a>
            </li>
            <li>
              <a href="/yearbook_admin_jobs/production_tracking">Production</a>
            </li>
            <li>
              <a href="/admin/campaigns?department=yearbook">Campaigns</a>
            </li>
          </ul>
        </li>



        <li>
          <a href="/export/students">
            Students
          </a>
        </li>
        <li>
          <a href="/orders">
            Orders
          </a>
        </li>
        <li>
          <a href="/admin/dashboards">
            Dashboard
          </a>
        </li>
        <li>
          <a href="/admin/sms_conversations" style={{ display: 'flex', alignItems: 'center', gap: '0.5em' }}>
            Messages
            {unreadSmsCount > 0 && (
              <span style={{
                backgroundColor: '#dc3545',
                color: 'white',
                borderRadius: '10px',
                padding: '2px 8px',
                fontSize: '12px',
                fontWeight: 'bold'
              }}>
                {unreadSmsCount}
              </span>
            )}
          </a>
        </li>
        <li>
          <a rel="nofollow" data-method="delete" href="/users/sign_out">Logout</a>
        </li>
      </ul>
    </nav>
  );
};

export default EmployeeNav;
